import axiosClient from './axiosClient';

const adaptiveApi = {
  createChainingAdaptiveTest: async (data) => {
    const url = '/units/adaptive-unit-create';
    return axiosClient.post(url, data);
  },
  getAiquestion: async (unitId) => {
    const url = `/user-courses/start-adaptive-ai-unit-question?id=${unitId}`;
    return axiosClient.post(url);
  },

  startAdaptiveAiUnitQuestion: async (unitId) => {
    const url = `/user-courses/start-adaptive-ai-unit-question?id=${unitId}`;
    return axiosClient.post(url);
  },

  getAiNavigate: async (unitId) => {
    const url = `/user-courses/get-adaptive-unit-state?id=${unitId}`;
    return axiosClient.get(url);
  },
  getSubmit: async (id, questionId, data) => {
    const url = `/user-courses/submit-unit-question-adaptive?id=${id}&question=${questionId}`;
    return axiosClient.post(url, data);
  },
  getAllAiQuestion: async (id) => {
    const url = `user-courses/get-adaptive-unit-question?id=${id}`;
    return axiosClient.get(url);
  },
  updateApi: async (data, { unitId, questionId, questionIndex, nextIndex }) => {
    const url = `user-courses/update-unit-question-adaptive`;
    return axiosClient.post(url, data, {
      params: {
        unitid: unitId,
        questionId,
        questionIndex,
        nextIndex,
      },
    });
  },

  getTableApi: async (unitId) => {
    const url = `user-courses/get-content-history?id=${unitId}`;
    return axiosClient.get(url);
  },
};

export default adaptiveApi;
